import React from 'react';
import { useState } from 'react';
const TestEnvironment = () => {
  const [accessToken, setAccessToken] = useState("");
  const [afasLink, setAfasLink] = useState("");

  async function getMetaInfo(){
    var response = await fetch('/afas/getMetaInfo', {
      method: 'GET',
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }
  async function fetchLink(){
    var response = await fetch('/afas/fetchLink', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        afasLink: afasLink,
      }),
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }

  const handleChangeAccess = (e) => {
    setAccessToken(e.target.value);
  };
  const handleChangeAfasLink = (e) => {
    setAfasLink(e.target.value);
  };

  return (
    <div className="">
      <div>
        <p>Access Token: </p>
        <input value={accessToken} onChange={handleChangeAccess} />
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{getMetaInfo();}}>Get MetaInfo</button> 
        <div>
          <p>Afas link: </p>
          <input value={afasLink} onChange={handleChangeAfasLink} />
        </div>
        <button className="import-btn hover" onClick={()=>{fetchLink();}}>Fetch Link</button> 
      </div>
    </div>
  );
};

export default TestEnvironment;
